const products = {
  "1-seat Sofa Bed, Tibbleby Beige-Grey": 38000,
  "100% Cotton 6 Seater Dinning Table Runner": 500,
  "2-Door Wardrobe Armoire with 2 Drawers, Modern Storage Solution for Bedrooms and Closets": 28000,
  "2-Door Wardrobe Armoire with LED Lights, Modern Storage Solution with Adjustable Shelves": 30000,
  "2-seat Sofa Bed, Gunnared Beige": 55000,
  "2-seat Sofa Bed, Vissle Yellow/Green": 30000,
  "3 Seater Cotton Striped Sofa Cover": 900,
  "3-Seat Modular Sofa in Samsala Dark Yellow-Green Fabric": 97000,
  "3-Seat Sofa Bed – Medium Grey": 100000,
  "3-seat Sofa Bed, Kilanda Light Beige": 68000,
  "4 Seater Cotton Dinning Table Cover": 1100,
  "3-Seat Sofa with Open End in Tonerud Red Fabric": 74000,
  "55-Inch Farmhouse Executive Desk with Drawers, File Cabinet, and Power Outlets": 28000,
  "Acacia Wood Chair": 7000,
  "Antique Stained Wooden Dining Chair": 8000,
  "Adjustable Sit-Stand Desk with White Finish for Ergonomic Workspace": 14000,
  "Armoire with Adjustable Shelves and Hanging Rod, Modern Storage Solution": 98000,
  "Armoire with Shelves and Hanging Rod, Classic Storage Solution for Bedroom and Living Spaces": 30000,
  "Birch Stackable 3-Legged Stool": 1500,
  "Black Checkered Cotton Bean Bag – Pre-Filled for Ultimate Comfort": 6000,
  "Black Leatherette Bean Bag – Without Beans": 1400,
  "Black Dining Set with Table and 4 Chairs": 8000,
  "Black Stained Wooden Dining Chair with Padded Seat": 9000,
  "Blue Floral Cotton Canvas Bean Bag – Without Bean": 1869,
  "Children’s White Wooden Chair": 4700,
  "Compact and Modern White Desk for Small Spaces": 8800,
  "Corner Workstation in White": 19000,
  "Cotton Stripes Runner For Center Table": 500,
  "Cotton Printed 4 Seater Dinning Table Runner": 500,
  "Dark Grey Sofa Bed with Storage": 10000,
  "Desk with Shelf Unit": 6500,
  "Dark Leopard Print Bean Bag & Chair – Stylish & Comfortable Seating for All Ages": 8000,
  "Day Bed Frame with 3 Drawers, White": 30000,
  "Floral Printed Cotton Dinning Table Cover For 4 Seater": 1000,
  "Foldable Outdoor Chair": 3500,
  "Green Cotton Printed Placemats – Set of 2 (13 x 18 Inches)": 300,
  "Folding Chair with Light Grey Seat": 6500,
  "Grey Plastic Stool For Multi Purpose": 555,
  "High Bed Frame with 4 Storage Boxes – Space-Saving & Stylish": 60000,
  "Junior Chair": 6000,
  "M Size Dalmatian Print Bean Bag Without Beans For Kids": 1200,
  "Magenta Floral Elegance Table Runner – 14 x 52 Inches": 400,
  "Multicolour Cotton Table Placemat – 19 x 13 Inches": 300,
  "Plastic Coffee Table in Pear Wood Colour": 890,
  "Plastic Chair in Brown Colour": 2000,
  "Premium Leatherette 3-Seater Recliner Sofa in Brown": 85000,
  "Printed Centre Table Cover – Small Size": 600,
  "Sit/Stand Desk with Adjustable Height": 11000,
  "Weathered Brown Plastic Coffee Table with Wheels": 400,
  "White Dining Table with 4 Chairs": 15000,
  "White Folding Chair": 7777,
  "XL Green Camouflage Cotton Bean Bag Without Beans": 1300,
  "Wall Mounted Folding Table in Oak Brown Colour": 2000,
  "Wall Mounted Table in Beige Finish": 2000,
  "Wall Mounted Table in White Finish": 2000,
  "Solid Color Centre Table Cover": 700,
  "Spindle Armchair with Beige/Grey Cushion": 8000,
  "Velvet Quilted 1-Seater Sofa Cover with Tassel – Green": 400,
  "Rome Fabric Italian Motorised Corner Recliner in Grey": 98000,
  "Soldi Cover For 3 Seater Sofa": 800,
  "Snow Leopard Print Bean Bag & Chair – Cozy & Stylish Seating for Kids and Adults": 10000,
  "Queen-Size Bed with Headboard and Storage – Anthracite": 97000,
  "Queen-Size Brown Bed Frame with Luröy Slats – Classic & Sturdy": 60000,
  "Recliner Sofa with Power Lift, Headrest, and Lumbar Support": 35000,
  "Red Premium Striped Round Fur Bean Bag & Couch Sofa – Stylish Comfort for Any Room": 12000,
  "Purple Striped Fur Bean Bag Chair & Couch Sofa – Soft & Cozy Seating": 9000,
  "Queen-Size Bed Frame – Pine": 35000,
  "Outdoor Stool with Braided Seat": 7500,
  "Pine Wood Stool": 2500,
  "Modern Desk with Storage – White and Turquoise": 4900,
  "Neo Kyoto Coffee Table": 45000,
  "Light Brown Stained Wooden Chair with Natural Upholstered Seat": 7000,
  "Light Grey Desk with Simple Design": 14000,
  "Grey Lounger-Style Bean Chair with Piping – Pre-Filled with Beans": 10000,
  "Grey Luxury Fur Bean Bag – Ultra-Soft & Cozy Seating": 9000,
  "Jumbo Black Jute Bean Bag Filled with Beans": 7000,
  "Kaba Marble Top Coffee Table with Whitewashed Wood Base": 90000,
  "Desk Combination with Storage": 11000,
  "Desk Combination with Storage – White, Light Grey, and Green": 10500,
  "Desk Combination with Storage, White": 8500,
  "Desk in White": 8000,
  "Desk with Shelf Unit in White": 6500,

};

const orgDetails = {
  orgName: "Quila Techplat Private Limited",
  phoneNumber: "+91 8750435980",
  gstNumber: "07AABCQ0281F1ZQ",
  orgAddress:
    "Office # 301/3, Garg Plaza, Bhera Enclaven, Sunder Vihar, Delhi, India- 110087",
};

const shortName = "QD";

const quilaD = { products, orgDetails, shortName };
export default quilaD;
